import graphql__c01297b049740dd27cbe from "./__generated__/ReactivateProjectDialog_project.graphql.ts";
import graphql__62941205791734da4b03 from "./__generated__/ReactivateProjectDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type ReactivateProjectDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const ReactivateProjectDialog: React.FC<ReactivateProjectDialogProps> = (props) => {

    const intl = useIntl();
    const navigate = useNavigate();
    const project = useFragment(
        graphql__c01297b049740dd27cbe,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__62941205791734da4b03,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                    navigate('/projects')
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToReactivateProject'})
            }
        )
    }

    const initialValues = {
        id: project.id
    }

    const projectDisplayName = project.projectName + (project.projectNumber ? ' (' + project.projectNumber + ')' : '');

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.ReactivateProjectDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.ReactivateProjectDialog.submitLabel'})}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.ReactivateProjectDialog.confirmMessage'}, {name: projectDisplayName})}
                    </p>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default ReactivateProjectDialog;
